// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"ca9da6b1","312":"b3a3f918","453":"04f9435e","484":"7518ebb8","551":"28b9a2d6","842":"38204d53","851":"03ac9902"}[chunkId] + ".chunk.js";
};